export class RadioModel {
    key: string;
    value: string;
    ariaLabel: string;
    dominioId?: number;
    additionalFields?: object

    constructor(key: string, value: string, ariaLabel: string, additionalFields?: object, dominioId?: number) {
        this.key = key;
        this.value = value;
        this.ariaLabel = ariaLabel;
        this.dominioId = dominioId;

        if (additionalFields) {
            this.additionalFields = additionalFields;
        }
    }
}
